import './App.css';
import './style.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, NavLink, Link } from 'react-router-dom';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';



//import Signup from './portal/Signup';
//import Login from './portal/Login';
//import PortalPage from './portal/PortalPage';
//import EnquiryDetail from './portal/EnquiryDetail';

//import TicketPage from './portal/TicketPage';




import Navbar from './components/Navbar';
import Home from './pages/Home';

import NewsPage from './pages/NewsPage';
import ArticleDetailPage from './pages/ArticleDetailPage'; 







import AdminLogin from './pages/AdminLogin';
import Footer from './components/FooterPage';




//import Chatbot from './components/Chatbot';







import AdminDashboard from './pages/AdminPage';
//import MRETable from './pages/Graph/mre';
import MREdata from './pages/MREdb';



// Wrapper to use hooks like useLocation
/*function AppWrapper() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const location = useLocation();

  // Hide Navbar and Footer on /admin only
  const hideLayout =
  location.pathname === '/admin' || location.pathname === '/admin/dashboard';



  return (
    <>
      {!hideLayout && <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />}

      <Routes>
        <Route path="/" element={<Home darkMode  ={darkMode} />} />

        
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />

  
  <Route path="/ticket/:ticketId" element={<TicketPage />} />


       
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}*/



// Wrapper to use hooks like useLocation
function AppWrapper() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const location = useLocation();

  // 🛑 THE FIX IS HERE: Include the dynamic path /ticket/
  const hideLayout =
    location.pathname === '/admin' ||
    location.pathname === '/admin/dashboard' ||
   // location.pathname.startsWith('/ticket/') ||
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/signup')||
     location.pathname === '/portal'  ||
     location.pathname === '/news-page'  ||
     location.pathname === '/article-detail-page'; 

    //location.pathname.startsWith('/portal');



  return (
    // Only show Navbar and Footer if hideLayout is false
    <>
      {!hideLayout && <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />}

      <main style={{ flexGrow: 1 }}> {/* Added flexGrow style from previous discussion */}
        <Routes>
          <Route path="/" element={<Home darkMode={darkMode} />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />


          <Route path="/news-page" element={<NewsPage />} />
        <Route path="/article-detail-page" element={<ArticleDetailPage />} />
        


        


          {/*<Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/portal" element={<PortalPage />} />*/}


 
        </Routes>
      </main>

      {!hideLayout && <Footer />}
    </>
  );
}
// ... rest of App.js ...



// Main app with single BrowserRouter
function App() {
  return (
    <BrowserRouter>
      <AppWrapper />

       
       

    </BrowserRouter>
  );
}

export default App;
